import { BalanceSheetId, Dtos, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { balanceSheetsQueryKey, financialPeriodsQueryKey } from "../../financials";

export function useAdminPromoteBalanceSheet(accountId: SuretyAccountId) {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (balanceSheetId: BalanceSheetId) =>
			post<Dtos.Admin.BalanceSheet.Get.Response>(
				`/v2/admin/surety/accounts/${accountId}/balance-sheets/${balanceSheetId}/promote`,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: balanceSheetsQueryKey(accountId) });
			queryClient.invalidateQueries({ queryKey: financialPeriodsQueryKey(accountId) });
		},
	});

	return {
		promoteBalanceSheet: mutation.mutate,
		promoteBSLoading: mutation.isPending,
		promoteBSError: mutation.error,
		resetPromoteBSError: mutation.reset,
	};
}
